"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const sharedUtils_1 = require("src/utils/sharedUtils");
const AppNavHeader_1 = __importDefault(require("src/components/organisms/AppNavHeader"));
const LetterIcon_1 = __importDefault(require("src/components/molecules/LetterIcon"));
const EditControl_1 = __importDefault(require("src/components/molecules/EditControl"));
const reduxHooks_1 = require("src/hooks/reduxHooks");
const thunk_1 = require("src/stores/exportedStore/clients/thunk");
const selectors_1 = require("src/stores/exportedStore/clients/selectors");
const selectors_2 = require("src/stores/applicationStore/auth/selectors");
const clientHeader_module_css_1 = __importDefault(require("./styles/clientHeader.module.css"));
const ClientHeader = ({ client }) => {
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const page = (0, reduxHooks_1.useAppSelector)(selectors_1.selectClientsPage);
    const me = (0, reduxHooks_1.useAppSelector)(selectors_2.selectUser);
    const onSuccessDelete = () => {
        navigate("/clients", { state: { page: page.current_page } });
    };
    const handleDelete = () => {
        if (!confirm(i18n_1.default.t("are you sure you want to delete the user?"))) {
            return;
        }
        dispatch((0, thunk_1.deleteUserThunk)(client.id, onSuccessDelete));
    };
    const controls = [
        {
            title: i18n_1.default.t("delete"),
            onClick: handleDelete,
            permission: "delete",
        },
    ].filter((item) => {
        return (0, sharedUtils_1.access)({ profile: me, section: "clients", permission: item.permission });
    });
    return ((0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: !!client && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: clientHeader_module_css_1.default.control }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: clientHeader_module_css_1.default.avatar }, { children: (0, jsx_runtime_1.jsx)(LetterIcon_1.default, { size: "lg", name: client.display_name }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: clientHeader_module_css_1.default.name }, { children: client.display_name })), controls.length > 0 && (0, jsx_runtime_1.jsx)(EditControl_1.default, { controls: controls })] }))), breadcrumbs: [{ title: i18n_1.default.t("Users"), url: "/clients" }] }));
};
exports.default = ClientHeader;
